import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { GET_URL } from '@utils/api/endpoints';
import { BaseResponse } from '@utils/types/shared/base';
import { AxiosError } from 'axios';

export type SessionDocument = {
  id: string;
  filename: string;
  language: string;
  type: string;
  created: string;
  last_modified: string;
  finished?: boolean;
};

type SessionDocumentsResponse = BaseResponse<SessionDocument[]>;

async function getSessionDocuments(
  sessionId: string
): Promise<SessionDocumentsResponse> {
  const { data } = await Axios.get(GET_URL(sessionId).sessionDocuments);
  return data;
}

export const SESSION_DOCUMENTS_QUERY_KEY = 'sessionDocuments';

export function useGetSessionDocuments(sessionId?: string) {
  return useQuery<SessionDocumentsResponse, AxiosError>(
    [SESSION_DOCUMENTS_QUERY_KEY, sessionId],
    () => getSessionDocuments(sessionId!),
    {
      enabled: !!sessionId,
      staleTime: 1000 * 60 * 5,
      refetchOnWindowFocus: false
    }
  );
}
